export default __webpack_public_path__ + "static/media/loading1.0f17a40d.gif";